// glabal
var Zpirit;

(function() {

	// Zpirit tests and properties
	Zpirit = {
		
		// DOM elements
		el: {},
		
		ua: window.navigator.userAgent,

		// run default functions here
		init: function() {
			// assign elements til this.el
			this.el = {
				doc: document.documentElement,
				head: document.head,
				body: document.body,
			};

			// We have jsvascript support
			this.js_support();
			this.svg_support();
			this.cookieNotice();

			// this.add_events();
		},

		// logs object items to console
		log_obj: function(obj) {
			for ( var el in obj ) {
				console.log( obj[el] );
			}
		},

		// JS Support, set class name in html element
		js_support: function() {
			this.el.doc.className = this.el.doc.className.replace( 'no-js', 'js' );
		},

		// SVG Support, set classname and replace .svg with .png
		svg_support: function() {
			if ( !! document.createElementNS && !! document.createElementNS('http://www.w3.org/2000/svg','svg').createSVGRect ) {
				this.el.doc.className = this.el.doc.className.replace( 'no-svg', 'svg' );
			}
			else {
				var imgs = document.querySelectorAll('img[src*=".svg"]'), 
					i;
				for ( i = 0; i < imgs.length; i++ ) {
					imgs[i].src = imgs[i].src.replace('.svg', '.png');
				}
			}
		},
		// check any css property for browser support
		css_prop_support: function(prop, value) {
			var d = document.createElement('div');
			d.style[prop] = value;
			return d.style[prop] === value;
		},

		screen_size_title: function() {
			// show current screen size in title
			document.title = window.innerWidth+"x"+window.innerHeight;
		},

		tooltiped: function() {
			var tooltips = document.querySelectorAll('.tooltiped');
			// Only proceede if we have a tooltip element and some text for it
			for ( var item of tooltips ) {
			 	// statements
				var tooltip_txt = item.getAttribute('aria-label');
				// create an item for the tip
				var span = document.createElement('span');
				span.className = 'tooltip';
				span.textContent = tooltip_txt;
				
				// add the tool tip to .tooltiped
				item.appendChild(span);
			 }
		},


		add_events: function() {
			this.screen_size_title();
			window.addEventListener('resize', this.screen_size_title, false);
		},

		// show cookie notice if not hidden by user
		cookieNotice: function() {
			if ( window.localStorage.getItem('hide-cookie-notice') === null ) {
				// no cookie preference is set by user, show cookie notice
				this.cookieNoticeCreate();
			}
		},
		// build cookie notice DOM
		cookieNoticeCreate: function() {
			// div id root
			var croot = document.getElementById('root');
			if ( ! croot ) {
				croot = document.createElement('div');
				croot.id="root";
				
				// script called to soon
				if ( ! document.body )
					return;

				document.body.appendChild(croot);
			}

			// create documentfragment
			var frag = document.createDocumentFragment();

			// create a div element
			var cdiv = document.createElement('div');
			cdiv.id = "cookie-notice";
			
			// create a paragraph
			var cpar = document.createElement('p');
			

			var lang = {
				no: ['Me nyttar informasjonskapslar på nettsida vår. Held du fram med å nytte nettstaden, godtek du det. ', 'Les meir' , 'innformasjonskapslar/'],
				nb: ['Vi bruker informasjonskapsler på nettsiden vår. Fortsetter du å bruke nettsiden, godtar du det. ', 'Les mer' , 'informasjonskapsler/']
			};
			
			// default language norwegian
			var current_lang = lang.no;
			
			// use english language if coockie is set	
			if ( window.location.host.indexOf('bedreinnsats.no') !== -1 || window.location.host.indexOf('bedre-innsats.no') !== -1 || window.location.host.indexOf('leirfjord') !== -1 || window.location.host.indexOf('varnes') !== -1 ) {
				current_lang = lang.nb;
			}
			
			cpar.textContent = current_lang[0];

			// check for privacy page and create a link to it
			var ajax = new XMLHttpRequest();
			ajax.open( 'GET', '/wp-json/wp/v2/pages?search=informasjonskapsl' );
			ajax.setRequestHeader( 'Content-Type', 'application/json' );
			ajax.onload = function() {
				if ( ajax.status === 200 ) {
					var result = JSON.parse(ajax.responseText);
					if ( result.length ) {

						result.forEach( function(element, index) {
							
							if ( element.slug.indexOf('informasjonskapsl') !== -1 ) {
								// create a link
								var clink = document.createElement('a');
								clink.href = element.link;
								
								clink.textContent = current_lang[1];

								// append link to paragraph
								cpar.appendChild(clink);
							}

						});
					}
				}
				else {
					console.log( "AJAX Error https status " + ajax.status );
				}
			};
			ajax.send();
			
			// append paragraph to div
			cdiv.appendChild(cpar);

			// creata a close button
			var cbut = document.createElement('button');
			cbut.id = "close-cookie-notice";
			cbut.addEventListener('click', this.cookieNoticeHide);
			
			// creata an fonticon element
			var cico = document.createElement('i');
			cico.className = "far fa-times";
			
			// append fonticon to button
			cbut.appendChild(cico);
			
			// append button to div
			cdiv.appendChild(cbut);
			
			// append div to fragment
			frag.appendChild(cdiv);
			
			// create style element
			var cstyle = document.createElement('style');
			// append styles to root 
			croot.appendChild(cstyle);
			var csheet = cstyle.sheet;
			var rules = [
				[
					"#cookie-notice", 
					[
						"position: fixed;",
						"bottom: 0;",
						"left: 0;",
						"background: #003050;",
						"width: 100%;",
						"color: #ffffff;",
						"text-align: center;",
						"padding: 30px 3em;",
						"z-index: 99;"
					]
				],
				[
					"#cookie-notice p",
					[
						"margin: 0;"
					]
				],
				[
					"#cookie-notice a",
					[
						"color: #ffffff;",
						"font-weight: 700;",
						"font-style: italic;",
						"text-decoration: underline;"
					]
				],
				[
					"#cookie-notice a:focus",
					[
						"outline: 1px dashed #ffffff;"
					]
				],
				[
					"#cookie-notice button",
					[
						"position: absolute;",
						"top: 12px;",
						"background: none;",
						"right: 25px;",
						"font-size: 1.8em;",
						"color: #ffffff;",
						"width: 2em;",
						"height: 2em;",
						"border: none;",
						"outline: none;"
					]
				],
				[
					"#cookie-notice button:focus",
					[
						"outline: 1px dashed #ffffff;"
					]
				],
				[
					"#cookie-notice button:hover",
					[
						"cursor: pointer;"
					]
				],
				[
					"@media all and (max-width: 991px)",
					[
						"#cookie-notice p { font-size: 1.2em; }",
						"#cookie-notice button { top: 6px; right: 6px; font-size: 1.4em; }",
					]
				],

			];
			for ( var i = 0; i < rules.length; i++ ) {
				var selector = rules[i][0];
				var props = "";
				for ( var r = 0; r < rules[i][1].length; r ++ ) {
					props += rules[i][1][r];
				}
				// append rules til stylesheet
				csheet.insertRule( selector + "{" + props + "}", csheet.cssRules.length);
			}
			
			// append fragment to root
			croot.appendChild(frag);
		},
		// Hides cookie notice
		cookieNoticeHide: function() {
			if( window.localStorage ) 
				window.localStorage.setItem('hide-cookie-notice', "true");
			
			var cockNotice = document.getElementById('cookie-notice');
			if ( cockNotice )
				cockNotice.parentNode.removeChild(cockNotice);
		}
	};

	// init the Zpirit object
	Zpirit.init();

})();